// src/components/Header.jsx
// The site's masthead: the strip across the top of every page.
// Contains the publication's identity (issue number, season) and the navigation.
//
// Visual structure (lifted from Module 7's index.html masthead):
// ┌──────────────────────────────────────────────────────────────────┐
// │  ISSUE 02   SUMMER 2026          COVER  FIELD NOTES  DISPATCHES…  │
// └──────────────────────────────────────────────────────────────────┘
//   ───────────────────── hairline below ──────────────────────────
//
// The masthead is purely identity + navigation. Content sections start below.
import Navigation from "./Navigation";

export default function Header() {
  return (
    <header className="border-b border-ink-20">
      <div className="max-w-wide mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-baseline gap-4">
          <span className="label-mono">Issue 02</span>
          <span className="label-mono">Summer 2026</span>
        </div>
        <Navigation />
      </div>
    </header>
  );
}
